import React from "react";
import { Nav } from "shards-react";

import Languages from "./Languages";
import UserActions from "./UserActions";

export default () => (
  <Nav navbar className="border-left flex-row">
    <Languages/>
    <UserActions />
  </Nav>
);
